window.$ = window.jQuery = require('jquery');

import { Swiper } from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

require('./web_function')

$(function () {

    let target = $('meta[name="target"]').attr('content')

    if(target){

        switch (target) {
            case 'mission':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-1", offsetY: 0 } });
                break;

            case 'vision':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-2", offsetY: 0 } });
                break;

            case 'operational-sites':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-3", offsetY: 0 } });
                break;
        }
    }

    new Swiper('#rd-recommendation-swiper', {
        slidesPerView: 1,
        navigation: {
            nextEl: '#rd-recommendation-swiper-next',
            prevEl: '#rd-recommendation-swiper-prev',
        }
    });
    changeLogoColor()
})

function changeLogoColor() {

    ScrollTrigger.create({
        trigger: "#rd-section-3",
        start: "top top",
        markers:false,
        onEnter: function () {
            switchHeaderBlue(false)
        },
        onEnterBack: function () {
            switchHeaderBlue(false)
        },
        onLeave: function () {
            switchHeaderBlue(true)
        },
        onLeaveBack: function () {
            switchHeaderBlue(true)
        }
    });

}
